import axios from "axios";
import React, { useEffect, useRef, useState } from "react";
import toast from "react-hot-toast";
import { useNavigate, useParams } from "react-router-dom";
import { BeatLoader, ClipLoader } from "react-spinners";

const MCQ = () => {
  const [candidateId, setCandidateId] = useState("");
  const [questions, setQuestions] = useState([]);
  const [hrQuestions, setHrQuestions] = useState([]);
  const [answers, setAnswers] = useState([]);
  const [hrAnswers, setHrAnswers] = useState([]);
  const [submitted, setSubmitted] = useState(false);
  const [allCorrect, setAllCorrect] = useState(true);
  const [loading, setLoading] = useState(false);
  const [loading2, setLoading2] = useState(false);
  const [fullLoading, setFullLoading] = useState(false);
  const [showGeneratedQuestions, setShowGeneratedQuestions] = useState(false);
  const [showFitmentQuestions, setShowFitmentQuestions] = useState(false);
  const [showForm, setShowForm] = useState(true);
  const [percentage, setPercentage] = useState(0);
  const [num, setNum] = useState(0);
  const [GPercentage, setGPercentage] = useState(0);
  const [GNum, setGNum] = useState(0);
  const [onlyHrQuestions, setOnlyHrQuestions] = useState([]);
  const [onlyQuestions, setOnlyQuestions] = useState([]);
  const [alreadySubmitted, setAlreadySubmitted] = useState(false);
  const [jobCode, setJobCode] = useState("");
  const [jobTitle, setJobTitle] = useState("");
  const [generateQuestions, setGenerateQuestions] = useState(false);
  const [saleryType, setSaleryType] = useState();
  const [saleryAmount, setSaleryAmount] = useState();
  const [seconds, setSeconds] = useState(200);
  const [dontIn, setDontIn] = useState(false);

  const intervalRef = useRef()

  const navigate = useNavigate()
  let { candidateId: candidateId2 } = useParams();

  useEffect(() => {
    if (saleryType && saleryAmount && !dontIn) {
      setNum(num + 1)
      setDontIn(true)
    }
  }, [saleryType, saleryAmount])

  useEffect(() => {
    if (showGeneratedQuestions && questions.length > 0) {
      intervalRef.current = setInterval(() => {
        setSeconds((prev) => prev - 1)
      }, 1000)
    }

    return () => {
      clearInterval(intervalRef.current)
    }
  }, [showGeneratedQuestions, questions])

  useEffect(() => {
    if (seconds === 0) {
      clearInterval(intervalRef.current)
      submitAnswer()
    }
  }, [seconds])

  useEffect(() => {
    setHrQuestions([
      {
        text: "Are you legally authorized to work in the United States?",
        correctAnswer: [
          "Yes, I am a citizen or permanent resident",
          "Yes, I have a work visa",
        ],
        options: [
          "Yes, I am a citizen or permanent resident",
          "Yes, I have a work visa",
          "No, I am not authorized",
        ],
      },
      {
        text: "Do you have a valid driver's license?",
        correctAnswer: ["Yes", "No"],
        options: ["Yes", "No"],
      },
      {
        text: "What is your availability to start a new job?",
        correctAnswer: [
          "Immediate",
          "1 week",
          "2 weeks",
          "3 weeks",
          "More than 4 weeks",
        ],
        options: [
          "Immediate",
          "1 week",
          "2 weeks",
          "3 weeks",
          "More than 4 weeks",
        ],
      },
      {
        text: "Preferred Employment Type",
        correctAnswer: ["1099", "C2C", "W2", "No preference"],
        options: ["1099", "C2C", "W2", "No preference"],
      },
      {
        text: "Which state do you currently reside in?",
        correctAnswer: [
          "Alabama",
          "Alaska",
          "Arizona",
          "Arkansas",
          "California",
          "Colorado",
          "Connecticut",
          "Delaware",
          "Florida",
          "Georgia",
          "Hawaii",
          "Idaho",
          "Illinois",
          "Indiana",
          "Iowa",
          "Kansas",
          "Kentucky",
          "Louisiana",
          "Maine",
          "Maryland",
          "Massachusetts",
          "Michigan",
          "Minnesota",
          "Mississippi",
          "Missouri",
          "Montana",
          "Nebraska",
          "Nevada",
          "New Hampshire",
          "New Jersey",
          "New Mexico",
          "New York",
          "North Carolina",
          "North Dakota",
          "Ohio",
          "Oklahoma",
          "Oregon",
          "Pennsylvania",
          "Puerto Rico",
          "Rhode Island",
          "South Carolina",
          "South Dakota",
          "Tennessee",
          "Texas",
          "Utah",
          "Vermont",
          "Virginia",
          "Washington",
          "West Virginia",
          "Wisconsin",
          "Wyoming",
        ],
        options: [
          "Alabama",
          "Alaska",
          "Arizona",
          "Arkansas",
          "California",
          "Colorado",
          "Connecticut",
          "Delaware",
          "Florida",
          "Georgia",
          "Hawaii",
          "Idaho",
          "Illinois",
          "Indiana",
          "Iowa",
          "Kansas",
          "Kentucky",
          "Louisiana",
          "Maine",
          "Maryland",
          "Massachusetts",
          "Michigan",
          "Minnesota",
          "Mississippi",
          "Missouri",
          "Montana",
          "Nebraska",
          "Nevada",
          "New Hampshire",
          "New Jersey",
          "New Mexico",
          "New York",
          "North Carolina",
          "North Dakota",
          "Ohio",
          "Oklahoma",
          "Oregon",
          "Pennsylvania",
          "Puerto Rico",
          "Rhode Island",
          "South Carolina",
          "South Dakota",
          "Tennessee",
          "Texas",
          "Utah",
          "Vermont",
          "Virginia",
          "Washington",
          "West Virginia",
          "Wisconsin",
          "Wyoming",
        ],
      },
      {
        text: "What is your expected salary?"
      },
      {
        text: "Will you be able to clear a comprehensive background check by the client or 3rd party?",
        correctAnswer: ["Yes", "No"],
        options: ["Yes", "No"],
      },
      {
        text: "Are you currently on a project?",
        correctAnswer: ["Yes", "No", "Ending soon"],
        options: ["Yes", "No", "Ending soon"],
      },
      {
        text: "Are you willing to relocate for this position?",
        correctAnswer: ["Yes", "No"],
        options: ["Yes", "No"],
      },
      {
        text: "How do you rate your communication skills 1-5, with 5 being the highest?",
        correctAnswer: ["1", "2", "3", "4", "5"],
        options: ["1", "2", "3", "4", "5"],
      },
    ]);
  }, []);

  useEffect(() => {
    const handlePopState = (event) => {
      navigate("/start");
    };

    window.addEventListener('popstate', handlePopState);

    return () => {
      window.removeEventListener('popstate', handlePopState);
    };
  }, [navigate]);

  useEffect(() => {
    const fetchJobDetails = async () => {
      try {
        setFullLoading(true);
        const response = await axios.post(
          `${import.meta.env.VITE_REACT_APP_BACKEND_BASEURL
          }/api/v1/check-candidate-id`,
          {
            candidate_id: candidateId2,
          },
          {
            withCredentials: true
          }
        );
        setFullLoading(false);
        setJobCode(response.data.job_code);
        setJobTitle(response.data.job_title);
      } catch (error) {
        setFullLoading(false)
        setAlreadySubmitted(true)
      }
    };
    fetchJobDetails();
  }, []);

  const handleInputChange = (e) => {
    setCandidateId(e.target.value);
  };

  const handleOptionChange = (questionIndex, option, text, options) => {
    setAnswers((prevAnswers) => {
      let updatedAnswers = [...prevAnswers];

      updatedAnswers[questionIndex] = { text, option, options };

      return updatedAnswers;
    });
    setOnlyQuestions((prevQuestions) => {
      if (!prevQuestions.includes(text)) {
        return [...prevQuestions, text];
      }
      return prevQuestions;
    });
    if (!onlyQuestions.includes(text)) {
      setGPercentage(GPercentage + 10);
      setGNum(GNum + 1);
    }
  };

  const handleHrOptionChange = (
    questionIndex,
    option,
    text,
    correctAnswer,
    options
  ) => {
    setHrAnswers((prevAnswers) => {
      let updatedAnswers = [...prevAnswers];
      updatedAnswers[questionIndex] = { text, correctAnswer, option, options };
      return updatedAnswers;
    });
    setOnlyHrQuestions((prevQuestions) => {
      if (!prevQuestions.includes(text)) {
        return [...prevQuestions, text];
      }
      return prevQuestions;
    });
    if (!onlyHrQuestions.includes(text)) {
      setPercentage(percentage + 11.1111111111);
      setNum(num + 1);
    }
  };

  const submitAnswer = async () => {
    if(answers.length < 10) {
      questions.forEach((question) => {
        const exists = answers.some((answer) => answer?.text === question?.text)
        if(!exists) {
          answers.push({
            option: "N/A (Not Attempted)",
            options: question.options,
            text: question?.text,
          })
        }
      })
    }
    setLoading((prev) => !prev);
    const response = await axios.post(
      `${import.meta.env.VITE_REACT_APP_BACKEND_BASEURL
      }/api/v1/create-answer`,
      {
        candidate_id: candidateId,
        answers,
      },
      {
        withCredentials: true
      }
    );
    if (response.data.success) {
      setSubmitted((prev) => !prev);
    }
    setLoading((prev) => !prev);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
  };

  const submitHrAnswer = async () => {
    setLoading(true);

    const unansweredQuestions = hrQuestions.some((question, index) => {
      if (question.text === "What is your expected salary?") {
        return false; // Skip this specific question from validation
      }
      return !hrAnswers[index];
    });

    if (unansweredQuestions || !saleryAmount || !saleryType) {
      toast.error("Please choose all the answers.");
      setLoading(false);
      return;
    }

    const salaryAmount = Number(saleryAmount);
    if (!Number.isFinite(salaryAmount) || salaryAmount <= 0) {
      toast.error("Please enter a valid salary amount.");
      setLoading(false);
      return;
    }

    let allCorrect = true;

    for (let index = 0; index < hrQuestions.length; index++) {
      const answer = hrAnswers[index];
      const correct =
        answer?.option === answer?.correctAnswer ||
        (Array.isArray(answer?.correctAnswer) &&
          answer?.correctAnswer.includes(answer?.option));

      if (!correct) {
        allCorrect = false;
        break;
      }
    }

    setAllCorrect(allCorrect);

    if (allCorrect) {
      setShowForm(false);
      setGenerateQuestions(true);
    } else {
      setShowGeneratedQuestions(false);
    }

    setLoading(false);
    try {
      let modifiedHrAnswers = [
        ...hrAnswers,
        {
          text: "What is your expected salary?",
          correctAnswer: ["no"],
          option: `${saleryType} ${saleryAmount}`,
          options: [`${saleryType} ${saleryAmount}`]
        }
      ]
      await axios.post(
        `${import.meta.env.VITE_REACT_APP_BACKEND_BASEURL
        }/api/v1/submit-hr-answers`,
        {
          candidate_id: candidateId,
          hrAnswers: modifiedHrAnswers,
        },
        {
          withCredentials: true
        }
      );
    } catch (error) {
      setGenerateQuestions(false)
      toast.error(error.response.data.message)
    }
  };

  const handleFetchQuestions = async () => {
    setLoading2((prev) => !prev);
    try {
      const response = await axios.post(
        `${import.meta.env.VITE_REACT_APP_BACKEND_BASEURL
        }/api/v1/generate-question`,
        {
          candidate_id: candidateId,
        },
        {
          withCredentials: true
        }
      );
      setQuestions(response.data.questions);
    } catch (error) {
      toast.error(error.response?.data?.message);
      setTimeout(() => {
        window.location.href = `/start/${candidateId}`
      }, 500)
    } finally {
      setLoading2((prev) => !prev);
    }
  };

  const handleFetchFitmentQuestions = async () => {
    setLoading2((prev) => !prev);
    try {
      const response = await axios.post(
        `${import.meta.env.VITE_REACT_APP_BACKEND_BASEURL
        }/api/v1/check-candidate-id`,
        {
          candidate_id: candidateId,
        },
        {
          withCredentials: true
        }
      );
      setJobCode(response.data.job_code);
      setJobTitle(response.data.job_title);
      setShowForm(false);
      setShowFitmentQuestions(true);
    } catch (error) {
      if (error.response.data.message === "Please enter correct id") {
        toast.error(error.response.data.message);
      } else {
        setAlreadySubmitted(true);
      }
    } finally {
      setLoading2((prev) => !prev);
    }
  };

  const handleProceed = () => {
    handleFetchQuestions();
    setShowFitmentQuestions(false);
    setGenerateQuestions(false);
    setShowGeneratedQuestions(true);
  };

  const closeSubmittedBox = async () => {
    window.location.href = "https://powersolv.com/career"
  };

  return (
    <div className="select-none"
      onCopy={(e) => e.preventDefault()}
      onContextMenu={(e) => e.preventDefault()}
      onSelectStart={(e) => e.preventDefault()}
      onDragStart={(e) => e.preventDefault()}>
      {!fullLoading ? (
        <div className={``}>
          <div
            className={`w-screen h-screen bg-[#0A0813E3] flex items-center justify-center fixed transition-opacity duration-200 ${!alreadySubmitted
              ? "opacity-0 scale-95 pointer-events-none"
              : "opacity-100 scale-100"
              }`}
          >
            <div
              className={`bg-white absolute rounded-[24px] shadow-md p-8 w-[311px] h-[353px] sm:h-[260px] sm:w-[360px] xl:h-[260px] xl:w-[403px] flex flex-col gap-4 items-center justify-center text-center xl:p-10 xl:gap-4 transition-transform duration-400`}
            >
              <img src="/images/error.png" className="w-[36px]" alt="" />
              <h2 className="font-bold text-[16px] leading-[122%] tracking-[0%] text-center   xl:text-[16px] 2xl:text-[18px] xxl:text-xl xl:leading-none text-[#5D0E23] xl:tracking-normal">
                You've already taken the test.
              </h2>
              <p className="font-medium text-[11px] leading-none tracking-[0%] text-center   xl:text-[11px] 2xl:text-[13px] xxl:text-[14px] xl:leading-none xl:tracking-normal text-[#636D80]">
                Thanks for submitting
              </p>
              <button
                type="button"
                onClick={closeSubmittedBox}
                className="mt-4 bg-[#5D0E23] hover:bg-[#55051A] font-semibold xl:text-[11px] 2xl:text-[12px] xxl:text-[13px] leading-none tracking-[-0.04em] text-center  cursor-pointer translate-all duration-400 text-white py-3 px-9  xl:py-3 2xl:py-4 xxl:py-5 xl:px-10 2xl:px-11 xxl:px-12 rounded-lg"
              >
                Go to job portal
              </button>
            </div>
          </div>

          {submitted ? (
            <div
              className={`w-screen h-screen bg-[#0A0813E3] flex items-center justify-center fixed z-[2] transition-opacity duration-400 ${submitted
                ? "opacity-100 scale-100"
                : "opacity-0 scale-95 pointer-events-none"
                }`}
            >
              <div
                className={`bg-white absolute transition-all duration-400  ${submitted ? "top-1/2" : "top-0"
                  } left-1/2 rounded-[24px] -translate-1/2 shadow-md p-8 w-[311px] h-[353px] sm:h-[260px] sm:w-[360px] xl:h-[260px] xl:w-[403px] flex flex-col gap-4 items-center justify-center text-center xl:p-10 xl:gap-4 transition-transform duration-400`}
              >
                <img
                  src="/images/congratulations.png"
                  className="w-[36px]"
                  alt=""
                />
                <h2 className="font-bold text-[16px] leading-[122%] tracking-[0%] text-center   xl:text-[16px] 2xl:text-[18px] xxl:text-xl xl:leading-none text-[#5D0E23] xl:tracking-normal">
                  Submitted!
                </h2>
                <p className="font-medium text-[11px] leading-none tracking-[0%] text-center   xl:text-[11px] 2xl:text-[13px] xxl:text-[14px] xl:leading-none xl:tracking-normal text-[#636D80]">
                  Your skill based assessment has been submitted successfully
                </p>
                <button
                  type="button"
                  onClick={closeSubmittedBox}
                  className="mt-4 bg-[#5D0E23] xl:block hidden hover:bg-[#55051A] font-semibold xl:text-[11px] 2xl:text-[12px] xxl:text-[13px] leading-none tracking-[-0.04em] text-center  cursor-pointer translate-all duration-400 text-white py-3 px-9  xl:py-3 2xl:py-4 xxl:py-5 xl:px-10 2xl:px-11 xxl:px-12 rounded-lg"
                >
                  Go to job portal
                </button>
              </div>
            </div>
          ) : (
            <div className={`flex flex-col`}>
              {!allCorrect || !showForm ? null : (
                <div className="xl:px-10 sm:px-8 mt-8 mb-8 px-3 ">
                  <div className="xl:flex xl:flex-row flex flex-col gap-6 xl:gap-0 sm:mb-28 xl:mb-12 lg:mb-10 2xl:mb-13 xxl:mb-14 xl:pb-6 sm:pb-5 xl:border-b sm:border-b border-[#D0CECE] items-start xl:items-center justify-between xl:px-6 sm:px-5">
                    <img
                      src="/images/Powersolv.png"
                      alt=""
                      className="w-28 xl:w-36 sm:w-32 2xl:w-40 xxl:w-44"
                    />
                    <div className="flex flex-col xl:flex-row sm:flex-row gap-2">
                      <p className="p-[10px] xl:p-[12px] sm:p-[11px] 2xl:p-[14px] xxl:p-4 rounded-[6px] text-white bg-[#86203B]">
                        <span className=" font-bold text-[11px] xl:text-[13px] sm:text-[12px] 2xl:text-[14px] leading-none tracking-normal">
                          Job Code:
                        </span>{" "}
                        <span className=" font-medium text-[11px] xl:text-[11px] sm:text-[11px] 2xl:text-[13px]  leading-none tracking-normal">
                          {jobCode}
                        </span>
                      </p>
                      <p className="p-[10px] xl:p-[12px] sm:p-[11px] 2xl:p-[14px] xxl:p-4 rounded-[6px] text-white bg-[#86203B]">
                        <span className="font-bold text-[11px] xl:text-[13px] sm:text-[12px] 2xl:text-[14px] leading-none tracking-normal">
                          Job Title:
                        </span>{" "}
                        <span className="font-medium text-[11px] xl:text-[11px] sm:text-[11px] 2xl:text-[13px]  leading-none tracking-normal">
                          {jobTitle}
                        </span>
                      </p>
                    </div>
                  </div>
                  <div
                    style={{ height: "calc(92vh - 174px)" }}
                    className="flex flex-col items-center justify-center text-center"
                  >
                    <h1 className="text-[#87213C] font-bold leading-none tracking-[0%]  Alt text-[34px] xl:text-[66px] sm:text-[54px] 2xl:text-[80px] xxl:text-[88px] ">
                      Powersolv PowerHires
                    </h1>
                    {showForm ? (
                      <form onSubmit={handleSubmit} className="">
                        <p className="font-medium text-[14px] xl:text-[16px] sm:text-[14px] 2xl:text-[21px] xxl:text-[20px] text-[#47474A] leading-none tracking-[0%]  mt-8 xl:mt-10 sm:mt-9 2xl:mt-11 xxl:mt-12">
                          Enter your Candidate ID provided in the Email
                        </p>
                        <input
                          type="text"
                          value={candidateId}
                          onChange={handleInputChange}
                          required
                          className="block my-3 mb-3 xl:mb-16 sm:mb-14 2xl:mb-[72px] xxl:mb-[80px] xl:my-16 sm:my-14 2xl:my-[72px] xxl:my-[80px] p-2 py-[14px] w-[330px] xl:w-[660px] sm:w-[560px] 2xl:w-[880px] xxl:w-[917px] pl-5 border bg-white border-[#D5D5D5] rounded-lg focus:outline-none box-border"
                          placeholder="Enter Candidate ID"
                        />
                        <button
                          disabled={loading2}
                          type="submit"
                          onClick={handleFetchFitmentQuestions}
                          className="hover:bg-[#55051A]  font-medium text-[16px] xl:text-[14px] sm:text-[14px] 2xl:text-[16px] xxl:text-[20px] leading-none tracking-[0%] bg-[#7F132F] text-[#FFFFFF] px-6 xl:py-[15px] sm:py-[13px] 2xl:py-[18px] xxl:py-5 py-3 w-[280px] xl:w-[310px] sm:w-[290px] 2xl:w-[384px] xxl:w-[444px] rounded-[10px] cursor-pointer mb-0 sm:mb-10 lg:mb-0"
                        >
                          {!loading2 ? (
                            "Let's Begin"
                          ) : (
                            <ClipLoader size={"1em"} color="white" />
                          )}
                        </button>
                      </form>
                    ) : null}
                  </div>
                </div>
              )}

              {showFitmentQuestions ? (
                <div className="">
                  <div>
                    <div
                      className={`w-screen h-screen z-[2] bg-[#0A0813E3] flex items-center justify-center fixed transition-opacity duration-400 ${!allCorrect
                        ? "opacity-100 scale-100"
                        : "opacity-0 scale-95 pointer-events-none"
                        }`}
                    >
                      <div
                        className={`bg-white absolute transition-all duration-400  ${!allCorrect ? "top-1/2" : "top-0"
                          } left-1/2 rounded-[24px] -translate-1/2 shadow-md p-8 w-[311px] h-[353px] sm:h-[260px] sm:w-[360px] xl:h-[260px] xl:w-[403px] flex flex-col gap-4 items-center justify-center text-center xl:p-10 xl:gap-4 transition-transform duration-400`}
                      >
                        <img
                          src="/images/error.png"
                          className="w-[36px]"
                          alt=""
                        />
                        <h2 className="font-bold text-[16px] leading-[122%] tracking-[0%] text-center   xl:text-[16px] 2xl:text-[18px] xxl:text-xl xl:leading-none text-[#5D0E23] xl:tracking-normal">
                          Thank You for Applying
                        </h2>
                        <p className="font-medium text-[11px] leading-none tracking-[0%] text-center   xl:text-[11px] 2xl:text-[13px] xl:leading-none xl:tracking-normal text-[#636D80]">
                          We are sorry , you do not qualify for this position
                        </p>
                        <button
                          type="button"
                          onClick={closeSubmittedBox}
                          className="hover:bg-[#55051A] mt-4 bg-[#5D0E23] font-semibold xl:text-[11px] 2xl:text-[12px] xxl:text-[13px] leading-none tracking-[-0.04em] text-center  cursor-pointer translate-all duration-400 text-white py-3 px-9  xl:py-3 2xl:py-4 xxl:py-5 xl:px-10 2xl:px-11 xxl:px-12 rounded-lg"
                        >
                          Go to job portal
                        </button>
                      </div>
                    </div>
                    <div
                      className={`w-screen h-screen z-[2] bg-[#0A0813E3] flex items-center justify-center fixed transition-opacity duration-400 ${generateQuestions
                        ? "opacity-100 scale-100"
                        : "opacity-0 scale-95 pointer-events-none"
                        }`}
                    >
                      <div
                        className={`bg-white absolute transition-all duration-400  ${generateQuestions ? "top-1/2" : "top-0"
                          } left-1/2 rounded-[24px] -translate-1/2 shadow-md p-8 w-[311px] h-[353px] sm:h-[260px] sm:w-[360px] xl:h-[260px] xl:w-[403px] flex flex-col gap-4 items-center justify-center text-center xl:p-10 xl:gap-4 transition-transform duration-400`}
                      >
                        <img
                          src="/images/congratulations.png"
                          className="w-[36px]"
                          alt=""
                        />
                        <h2 className="font-bold text-[16px] leading-[122%] tracking-[0%] text-center   xl:text-[16px] 2xl:text-[18px] xxl:text-xl xl:leading-none text-[#5D0E23] xl:tracking-normal">
                          Congratulations!
                        </h2>
                        <p className="font-medium text-[11px] leading-none tracking-[0%] text-center   xl:text-[11px] 2xl:text-[13px] xxl:text-[14px] xl:leading-none xl:tracking-normal text-[#636D80]">
                          You have met the requirement of HR Assessment.
                        </p>
                        <button
                          type="button"
                          onClick={handleProceed}
                          className="mt-4 bg-[#5D0E23] hover:bg-[#55051A] font-semibold xl:text-[11px] 2xl:text-[12px] xxl:text-[13px] leading-none tracking-[-0.04em] text-center  cursor-pointer translate-all duration-400 text-white py-3 px-9  xl:py-3 2xl:py-4 xxl:py-5 xl:px-10 2xl:px-11 xxl:px-12 rounded-lg"
                        >
                          Proceed To Skill Test
                        </button>
                      </div>
                    </div>
                    <div className="py-3 px-3">
                      <div className="xl:flex xl:flex-row flex flex-col gap-6 xl:gap-0 mb-1 sm:mb-2 xl:mb-2 lg:mb-3 2xl:mb-3 xl:pb-2 sm:pb-2 xl:border-b sm:border-b border-[#D0CECE] items-start xl:items-center justify-between xl:px-3 sm:px-3">
                        <img
                          src="/images/Powersolv.png"
                          alt=""
                          className="w-24 sm:w-28 xl:w-28 2xl:w-34"
                        />
                        <div className="flex flex-col xl:flex-row sm:flex-row gap-1 sm:gap-2">
                          <p className="p-[6px] xl:p-[8px] sm:p-[8px] 2xl:p-[10px] rounded-[6px] text-white bg-[#86203B]">
                            <span className=" font-bold text-[9px] xl:text-[12px] sm:text-[11px] 2xl:text-[12px]  ">
                              Job Code:
                            </span>{" "}
                            <span className=" font-medium text-[9px] xl:text-[12px] sm:text-[11px] 2xl:text-[12px]   ">
                              {jobCode}
                            </span>
                          </p>
                          <p className="p-[6px] xl:p-[8px] sm:p-[8px] 2xl:p-[10px] rounded-[6px] text-white bg-[#86203B]">
                            <span className="font-bold text-[9px] xl:text-[12px] sm:text-[11px] 2xl:text-[12px]  ">
                              Job Title:
                            </span>{" "}
                            <span className="font-medium text-[9px] xl:text-[12px] sm:text-[11px] 2xl:text-[12px]   ">
                              {jobTitle}
                            </span>
                          </p>
                        </div>
                      </div>
                      {allCorrect ? (
                        <h2 className="font-semibold text-[16px] leading-none tracking-[0%] sm:text-[24px] xl:text-[28px] 2xl:text-[32px] text-[#86203B] pb-0">
                          HR Assessment
                        </h2>
                      ) : null}
                      <div className="flex flex-col items-center">
                        <h1 className="mt-1 self-start w-[80%]  font-semibold text-[14px] leading-none tracking-[1%] sm:text-[20px] xl:text-[22px] 2xl:text-[24px] text-[#353535]">
                          Please answer these preliminary questions
                        </h1>
                        <p className="self-start w-[80%] mt-2  font-medium text-[10px] tracking-[1%] sm:text-[14px]  xl:text-[14px] 2xl:text-[16px] text-[#3E4054]">
                          This test is designed to gather essential information
                          to determine whether you meet the required criteria.{" "}
                          <br />
                          <span className="text-[#8F2B45] ">
                            Please read each question carefully and select the
                            best answer.
                          </span>
                        </p>
                        <div className="sticky top-0 pb-1 sm:pb-2 self-start w-full bg-white z-[1]">
                          <p className="font-medium text-[12px] leading-none pb-1 pt-1 tracking-[1%] sm:text-[14px] sm:leading-none xl:text-[14px] 2xl:text-[16px] xl:leading-none text-[#3E4054]">
                            <span>{num}</span>/<span>10</span>
                          </p>
                          <div className="stop-0 w-full">
                            <div
                              style={{ width: `${percentage}%` }}
                              className={`absolute h-[5.5px] sm:h-[7px] xl:h-[7px] 2xl:h-[9px] bg-[#86203B] rounded-[12px]`}
                            ></div>
                            <div className="w-full h-[5.5px] sm:h-[7px] xl:h-[7px] 2xl:h-[9px] bg-[#FCFCFC] rounded-[12px]"></div>
                          </div>
                        </div>
                        <ul
                          className={`space-y-2 self-start w-full ${!allCorrect || generateQuestions ? "hidden" : null}`}
                        >
                          {hrQuestions?.map((question, index) => (
                            <li
                              key={index}
                              className="p-2 sm:p-2 xl:p-2 border-[0.5px] border-[#B4BBC8] rounded-[6px]"
                            >
                              <p className="font-medium text-[12px] leading-none tracking-[0%] sm:text-[14px]  text-black pb-1 sm:pb-2">
                                Q{index + 1}. <span className="">{question.text} {question?.text === "What is your expected salary?" && "($USD)"}</span>
                              </p>
                              <div className="">
                                {question.text === "Which state do you currently reside in?" ? (
                                  <div className="relative w-[98%] mx-auto">
                                    <select
                                      aria-label="Current state"
                                      className="appearance-none text-[10px] sm:text-[12px] p-1 sm:p-1 border focus:border-[1px] border-[#AFA9A9] focus:border-[#AFA9A] focus:outline-none rounded-[6px] text-[#8F2B45] px-3 sm:ml-1 xl:ml-2 w-full bg-white -z-1"
                                      onChange={(e) => {
                                        const selectedValue = e.target.value;
                                        if (selectedValue !== "" && selectedValue !== "null") {
                                          handleHrOptionChange(
                                            index,
                                            selectedValue,
                                            question.text,
                                            question.correctAnswer,
                                            question.options
                                          );
                                        }
                                      }}
                                    >
                                      <option value="null">Select a state</option>
                                      {question?.options?.map((option, idx) => (
                                        <option key={idx} value={option}>
                                          {option}
                                        </option>
                                      ))}
                                    </select>

                                    {/* Custom Arrow */}
                                    <div className="absolute right-3 sm:right-2 xl:right-0 top-1/2 -translate-y-1/2 pointer-events-none">
                                      <svg
                                        className="w-3 h-4 text-gray-500"
                                        fill="none"
                                        stroke="currentColor"
                                        strokeWidth="2"
                                        viewBox="0 0 24 24"
                                        xmlns="http://www.w3.org/2000/svg"
                                      >
                                        <path
                                          strokeLinecap="round"
                                          strokeLinejoin="round"
                                          d="M19 9l-7 7-7-7"
                                        ></path>
                                      </svg>
                                    </div>
                                  </div>
                                ) : (
                                  question.text === "What is your expected salary?" ?
                                    <div className="relative w-[98%] mx-auto flex flex-col gap-2">
                                      {/* Radio Buttons */}
                                      <div className="flex items-center gap-4 text-[10px] sm:text-[12px] text-[#8F2B45]">
                                        <label className="flex items-center gap-1">
                                          <input
                                            type="radio"
                                            name={`rateType-${index}`}
                                            value="Monthly"
                                            onChange={(e) =>
                                              setSaleryType("Monthly")
                                            }
                                            className="accent-[#8F2B45]"
                                          />
                                          Yearly Salary (W2 + Benefits)
                                        </label>
                                        <label className="flex items-center gap-1">
                                          <input
                                            type="radio"
                                            name={`rateType-${index}`}
                                            value="Hourly"
                                            onChange={(e) =>
                                              setSaleryType("Hourly")
                                            }
                                            className="accent-[#8F2B45]"
                                          />
                                          Hourly Rate
                                        </label>
                                      </div>

                                      {/* Input Field for Value */}
                                      <input
                                        aria-label="Expected salary amount"
                                        type="number"
                                        min="1"
                                        placeholder="Enter amount"
                                        className="text-[10px] sm:text-[12px] p-1 border border-[#AFA9A9] focus:border-[#AFA9A] focus:outline-none rounded-[6px] text-[#8F2B45] px-3 bg-white w-full"
                                        onChange={(e) => {
                                          const amountValue = e.target.value;
                                          setSaleryAmount(amountValue)
                                        }}
                                      />
                                    </div>
                                    :
                                    <div>
                                      <ul className="space-y-2">
                                        {question?.options?.map((option, idx) => (
                                          <li
                                            key={idx}
                                            className="flex items-center space-x-1 mb-[2px]"
                                          >
                                            <label htmlFor={`option-${index}-${idx}`}>
                                              <input
                                                type="radio"
                                                name={`question-${index}`}
                                                id={`option-${index}-${idx}`}
                                                value={option}
                                                onChange={() =>
                                                  handleHrOptionChange(
                                                    index,
                                                    option,
                                                    question.text,
                                                    question.correctAnswer,
                                                    question.options
                                                  )
                                                }
                                                className="peer sr-only"
                                              />
                                              <div className="w-[15px] h-[15px] sm:w-5 sm:h-5 xl:w-4 xl:h-4 border bg-[#E2E2E2] border-[#E2E2E2] rounded-full flex items-center justify-center peer-checked:border-[#86203B] peer-checked:bg-[#86203B]">
                                                {/* Inner dot (Will be hidden by default) */}
                                                <div className="w-[9px] h-[9px] sm:w-3 sm:h-3 xl:w-2 xl:h-2 bg-[#E2E2E2] rounded-full transition-all peer-checked:bg-white"></div>
                                              </div>
                                            </label>
                                            <label
                                              htmlFor={`option-${index}-${idx}`}
                                              className="font-medium  tracking-[0%] text-[10px] sm:text-[12px]"
                                            >
                                              {option}
                                            </label>
                                          </li>
                                        ))}
                                      </ul>
                                    </div>
                                )}
                              </div>
                            </li>
                          ))}
                        </ul>

                        <button
                          disabled={loading}
                          onClick={submitHrAnswer}
                          type="submit"
                          className={`${!allCorrect || generateQuestions ? "hidden" : null}  hover:bg-[#55051A] font-semibold text-[12px] sm:text-[14px] xl:text-[14px] 2xl:text-[16px] leading-none tracking-[0%] bg-[#86203B] rounded-[6px] text-white w-[364px] sm:w-[180px] xl:w-[200px] 2xl:w-[270px] py-4 sm:py-3 xl:py-3 2xl:py-4 mt-1 sm:mt-2 cursor-pointer`}
                        >
                          {loading ? <ClipLoader color="white" size={"1em"} /> : "Submit"}
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              ) : null}

              {showGeneratedQuestions ? (
                <div>
                  {questions.length > 0 ? (
                    <div className="py-3 px-3">
                      <div className="xl:flex xl:flex-row flex flex-col gap-6 xl:gap-0 mb-1 sm:mb-2 xl:mb-2 lg:mb-3 2xl:mb-3 xl:pb-2 sm:pb-2 xl:border-b sm:border-b border-[#D0CECE] items-start xl:items-center justify-between xl:px-3 sm:px-3">
                        <img
                          src="/images/Powersolv.png"
                          alt=""
                          className="w-24 sm:w-28 xl:w-28 2xl:w-34"
                        />
                        <div className="flex flex-col xl:flex-row sm:flex-row gap-1 sm:gap-2">
                          <p className="p-[6px] xl:p-[8px] sm:p-[8px] 2xl:p-[10px] rounded-[6px] text-white bg-[#86203B]">
                            <span className=" font-bold text-[9px] xl:text-[12px] sm:text-[11px] 2xl:text-[12px] leading-none tracking-normal">
                              Job Code:
                            </span>{" "}
                            <span className=" font-medium text-[9px] xl:text-[12px] sm:text-[11px] 2xl:text-[12px]  leading-none tracking-normal">
                              {jobCode}
                            </span>
                          </p>
                          <p className="p-[6px] xl:p-[8px] sm:p-[8px] 2xl:p-[10px] rounded-[6px] text-white bg-[#86203B]">
                            <span className="font-bold text-[9px] xl:text-[12px] sm:text-[11px] 2xl:text-[12px] leading-none tracking-normal">
                              Job Title:
                            </span>{" "}
                            <span className="font-medium text-[9px] xl:text-[12px] sm:text-[11px] 2xl:text-[12px]  leading-none tracking-normal">
                              {jobTitle}
                            </span>
                          </p>
                        </div>
                      </div>
                      <h2 className="font-semibold text-[16px] leading-none tracking-[0%] sm:text-[24px] xl:text-[28px] 2xl:text-[32px] text-[#86203B] pb-0">
                        Skills Assessment
                      </h2>
                      <div>
                        <div className="flex flex-col items-center">
                          <h1 className="mt-1 self-start w-[80%]  font-semibold text-[14px] leading-none tracking-[1%] sm:text-[20px] xl:text-[22px] 2xl:text-[24px] text-[#353535]">
                            Let's test your core knowledge!
                          </h1>
                          <p className="self-start w-[80%] mt-2  font-medium text-[10px] tracking-[1%] sm:text-[14px]  xl:text-[14px] 2xl:text-[16px] text-[#3E4054]">
                            This test is designed to evaluate your technical
                            expertise and skill set to match the job
                            description. <br />
                            <span className="text-[#8F2B45]">
                              Please read each question carefully and select the
                              best answer.
                            </span>
                          </p>
                          <div className="sticky top-0 pb-1 sm:pb-2 self-start w-full bg-white z-[1]">
                            <div className="font-medium  flex justify-between items-center text-[12px] leading-none pb-1 pt-1 tracking-[1%] sm:text-[14px] sm:leading-none xl:text-[14px] 2xl:text-[16px] xl:leading-none text-[#3E4054]">
                              <div><span>{GNum}</span>/
                                <span>{questions.length}</span></div>
                              <span className="pl-2 text-red-500 text-[20px] sm:text-[24px] lg:text-[28px]">Time Left: {seconds} Seconds</span>
                            </div>
                            <div className="stop-0 w-full">
                              <div
                                style={{ width: `${GPercentage}%` }}
                                className={`absolute h-[5.5px] sm:h-[7px] xl:h-[7px] 2xl:h-[9px] bg-[#86203B] rounded-[12px]`}
                              ></div>
                              <div className="w-full h-[5.5px] sm:h-[7px] xl:h-[7px] 2xl:h-[9px] bg-[#FCFCFC] rounded-[12px]"></div>
                            </div>
                          </div>
                          <div className="flex flex-col items-center w-full">
                            <ul className="space-y-2 self-start w-full">
                              {questions?.map((question, index) => (
                                <li
                                  key={index}
                                  className="p-2 sm:p-2 xl:p-2 border-[0.5px] border-[#B4BBC8] rounded-[6px]"
                                >
                                  <p className="font-medium text-[12px] leading-none tracking-[0%] sm:text-[14px] text-black pb-1 sm:pb-2">
                                    Q{index + 1}. {question.text}
                                  </p>
                                  <div className="">
                                    <div>
                                      <ul className="space-y-2">
                                        {question?.options?.map((option, idx) => (
                                          <li
                                            key={idx}
                                            className="flex items-center space-x-1 mb-[2px]"
                                          >
                                            <label
                                              htmlFor={`option-${index}-${idx}`}
                                            >
                                              <input
                                                type="radio"
                                                name={`question-${index}`}
                                                id={`option-${index}-${idx}`}
                                                value={option}
                                                onChange={() =>
                                                  handleOptionChange(
                                                    index,
                                                    option,
                                                    question.text,
                                                    question.options
                                                  )
                                                }
                                                className="peer sr-only"
                                              />
                                              <div className="w-[15px] h-[15px] sm:w-5 sm:h-5 xl:w-4 xl:h-4 border bg-[#E2E2E2] border-[#E2E2E2] rounded-full flex items-center justify-center peer-checked:border-[#86203B] peer-checked:bg-[#86203B]">
                                                {/* Inner dot (Will be hidden by default) */}
                                                <div className="w-[9px] h-[9px] sm:w-3 sm:h-3 xl:w-2 xl:h-2 bg-[#E2E2E2] rounded-full transition-all peer-checked:bg-white"></div>
                                              </div>
                                            </label>
                                            <label
                                              htmlFor={`option-${index}-${idx}`}
                                              className="font-medium  tracking-[0%] text-[10px] sm:text-[12px]"
                                            >
                                              {option}
                                            </label>
                                          </li>
                                        ))}
                                      </ul>
                                    </div>
                                  </div>
                                </li>
                              ))}
                            </ul>

                            <button
                              disabled={loading || seconds < 1}
                              onClick={submitAnswer}
                              type="submit"
                              className=" hover:bg-[#55051A] font-semibold text-[12px] sm:text-[14px] xl:text-[14px] 2xl:text-[16px] leading-none tracking-[0%] bg-[#86203B] rounded-[6px] text-white w-[364px] sm:w-[180px] xl:w-[200px] 2xl:w-[270px] py-4 sm:py-3 xl:py-3 2xl:py-4 mt-1 sm:mt-2 cursor-pointer"
                            >
                              {loading ? (
                                <ClipLoader color="white" size={"1em"} />
                              ) : (
                                "Submit"
                              )}
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  ) : (
                    <div className="relative w-full h-screen">
                      <img
                        src="/images/Powersolv.png"
                        alt=""
                        className="w-28 sm:w-32 xl:w-36 2xl:w-40 xxl:w-44 sm:pt-5 sm:pl-5 xl:pt-6 xl:pl-6 pt-3 pl-3"
                      />
                      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 text-center flex flex-col items-center justify-center w-full">
                        <h2 className="flex items-center justify-center gap-1  font-semibold text-[23px] sm:text-[20px] xl:text-[22px] 2xl:text-[29px] xxl:text-[28px] tracking-[1%] text-[#7F1330] w-[344px] sm:w-[360px] xl:w-fit text-center">
                          <span>Your assessment is loading</span>
                          <span className="pt-2">
                            <BeatLoader color="#7F1330" size={"0.2em"} />
                          </span>
                        </h2>
                        <ClipLoader color="#7F1330" className="mt-2 sm:mt-3" />
                      </div>
                    </div>

                  )}
                </div>
              ) : null}
            </div>
          )}
        </div>
      ) : (
        <ClipLoader className="absolute top-1/2 left-1/2 -translate-1/2" />
      )}
    </div>
  );
};

export default MCQ;
